<template>
  <FriedModal :size="ModalSize.XLarge" :padded="false" closable @close="$emit('close')">
    <div class="subscription-welcome-modal">
      <div class="info-header-container">
        <div class="image-container hidden-xs-and-down">
          <div class="rocket" />
        </div>
        <div class="text-container">
          <FriedH3>{{ $t('plans_information_welcome_title') }}</FriedH3>
          <FriedParagraph>{{ $t('plans_information_welcome_description') }}</FriedParagraph>
        </div>
      </div>
      <div class="info-body">
        <PlansInformation />
      </div>
    </div>
    <template #footer>
      <FriedModalButtonsFooter class="buttons-footer">
        <FriedButton
          :button-type="ButtonType.Secondary"
          data-external="subscription-welcome-modal-not-now-btn"
          @click="$emit('close')"
          >{{ t('trial_plan_button_not_now') }}
        </FriedButton>
        <FriedButton
          :color="RainbowColor.Lilac"
          data-external="subscription-welcome-modal-contact-btn"
          @click="openChat"
        >
          <template #leftIcon>
            <FriedIcon icon="publish" />
          </template>
          {{ t('contact-us') }}
        </FriedButton>
      </FriedModalButtonsFooter>
    </template>
  </FriedModal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { ButtonType, RainbowColor, ModalSize } from '@getaccept/fried-tofu';
import { useIntercomChat } from '@getaccept/lib-shared/src/composables/intercom-chat.composable';
import PlansInformation from './PlansInformation.vue';

export default defineComponent({
  components: { PlansInformation },
  emits: ['close'],
  setup(_, { emit }) {
    const { openChat: openIntercomChat } = useIntercomChat();

    const openChat = () => {
      openIntercomChat();
      emit('close');
    };

    return {
      RainbowColor,
      t,
      openChat,
      ButtonType,
      ModalSize,
    };
  },
});
</script>
<style lang="scss" scoped>
.subscription-welcome-modal {
  display: flex;
  flex-direction: column;
  width: 100%;

  .info-header-container {
    display: flex;
    justify-content: center;
    gap: var(--spacing-100);
    width: 100%;
    padding: var(--spacing-75);
    border-radius: 0 var(--radius-medium);
    background-image: url('../assets/palette.svg?url');
    background-repeat: no-repeat;
    background-size: cover;

    @media screen and (max-width: $xs) {
      flex-direction: column;
    }

    .image-container {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;

      .rocket {
        width: 118px;
        height: 118px;
        background-image: url('@getaccept/lib-shared/src/assets/rocket.gif');
        background-size: cover;
        position: relative;
        z-index: 1;
        mix-blend-mode: darken;
      }
    }

    .text-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-right: calc(var(--spacing-200) * 2);
      gap: var(--spacing-25);
    }
  }

  .header {
    padding: var(--spacing-50) 0 var(--spacing-200);
  }
}

.info-body {
  padding: var(--spacing-150) var(--spacing-150) 0;
}

.buttons-footer {
  padding: 0 var(--spacing-150) var(--spacing-150);
}
</style>
